export class FSxRestoreDestinationWindowsRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "activeDirectory",
            "baseName": "activeDirectory",
            "type": "FSxRestoreDestinationWindowsRestoreOptionsActiveDirectory",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FSxRestoreDestinationWindowsRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
